import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import React, { useState, useEffect } from "react";
import { Tooltip, ThemeProvider } from "@mui/material";
import { tooltipsTheme } from "../../CustomThemes/ToolTipThemes";
import AutocompleteNotes from "../../Utils/AutocompleNotes";
import "./formRow.css";
import { SelectDropdown } from "../../Utils/SelectDropdown";
import { DateCalendar } from "../../Utils/DateCalendar";
import delete_Icon from "../../../../images/delete_icon.svg";

// The property names will be read
// Drop down menu for value and quality column

function FormRow({
  index,
  property,
  values,
  qualities,
  note,
  valueOptions,
  qualityOptions,
  onValueChange,
  onQualityChange,
  onNotesChange,
  compulsoryValue,
  tooltip,
  clearClicked,
  handleClearInput, // tool tip description for properties in form
  isUnfilled,
  height,
  onHeightChange,
}) {
  const [value, setValue] = useState(values || ""); // Local state for value input
  const [notes, setNotes] = useState(note || "");
  const [compulsory, setCompulsory] = useState(false); // Local state for compulsory/optional value input
  const [rowHeight, setRowHeight] = useState("38px"); //set regular row height to 38px

  const handleResize = (newHeight) => {
    setRowHeight(newHeight); // Update height based on the taller content
  };
  //The following variables are necessary for RepX files
  let snapshotName = localStorage.getItem("selectedSnapshot");
  let isRepXFile = snapshotName.toLowerCase().includes("repx");
  const snapshotLocationProperty = property === "snapshot_location";
  const snapshotNameProperty = property === "snapshot_name";
  const snapshotDataLocationProperty = property === "data_loc";

  //compulsory values
  useEffect(() => {
    setCompulsory(compulsoryValue === "TRUE" && value === "");
  }, [compulsoryValue, value]);

  // Remove currency symbols and commas in the free text number input field
  const numericValue = parseFloat(
    values ? values.toString().replace(/,/g, "").replace(/[£]/g, "") : ""
  );

  return (
    <tr className={isUnfilled ? "unfilled-row" : ""}>
      {/* Property Column */}
      <td>
        <ThemeProvider theme={tooltipsTheme}>
          <Tooltip title={tooltip} className="property-tooltip-box">
            <div>
              {property}
              {(compulsoryValue === "TRUE" || compulsoryValue === "true") && (
                <span className="input-form-mandatory-field">*</span>
              )}
            </div>
          </Tooltip>
        </ThemeProvider>
      </td>

      {/* Values Column - Conditional rendering */}
      <td>
        {valueOptions === "Free text" ? (
          <div className="textarea-input-wrapper">
            <textarea
              style={{ height: height }}
              className="formrow-value-textareainput"
              type="text"
              placeholder="Write your text..."
              value={values}
              onChange={(e) => {
                setValue(e.target.value);
                onValueChange(e.target.value);
                handleResize(`${e.target.scrollHeight}px`);
              }}
              rows={1}
              //In RepX files these fields must be readOnly and disabled to prevent issues in generating RepX output
              readOnly={
                isRepXFile &&
                (snapshotDataLocationProperty ||
                  snapshotLocationProperty ||
                  snapshotNameProperty)
              }
              disabled={
                isRepXFile &&
                (snapshotDataLocationProperty ||
                  snapshotLocationProperty ||
                  snapshotNameProperty)
              }
            />
          </div>
        ) : valueOptions === "Date format" ? (
          <>
            <DateCalendar
              values={values}
              onValueChange={onValueChange}
              valueOptions={valueOptions}
            />
          </>
        ) : valueOptions === "Free text (number format)" ? (
          <>
            <input
              className="formrow-value-numberinput"
              type="number"
              placeholder="Choose a number value..."
              value={numericValue}
              onChange={(e) => {
                setValue(e.target.value);
                onValueChange(e.target.value);
              }}
            />
          </>
        ) : valueOptions === "Long Value" ? (
          <>
            <textarea
              style={{ height: height }}
              className="formrow-value-textareainput"
              placeholder="Write your value..."
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
                onValueChange(e.target.value);
                onHeightChange(e.target.scrollHeight + "px");
              }}
            />
          </>
        ) : (
          <SelectDropdown
            values={values}
            valueOptions={valueOptions}
            onValueChange={onValueChange}
          />
        )}
      </td>

      <td>
        <SelectDropdown
          values={qualities}
          valueOptions={qualityOptions}
          onValueChange={onQualityChange}
        />
      </td>
      <td>
        <AutocompleteNotes
          note={note}
          onNotesChange={(newNotes) => {
            setNotes(newNotes);
            onNotesChange(newNotes);
          }}
          height={height}
          handleResize={(height) => handleResize(`${height}px`)}
        />
      </td>
      <td>
        {clearClicked && (
          <button
            className="bin-icon-delete"
            onClick={() => handleClearInput(property)}
          >
            <img src={delete_Icon} alt="bin icon" />
          </button>
        )}
      </td>
    </tr>
  );
}

export default FormRow;
